import { AUTH } from 'src/constants'
import { redirect } from 'src/helpers/browser'

const Logout = () => {
  redirect(AUTH.SSO_REDIRECT_URI)
  return null
}

export default Logout
